<script setup>
    const props = defineProps({ modelValue: String });
    const emit = defineEmits(['update:modelValue']);
</script>

<template>
    <div class="input-group mb-2">
        <span class="input-group-text"><i class="bi bi-search"></i></span>
        <input
            type="search"
            class="form-control"
            placeholder="Search..."
            :value="props.modelValue"
            @input="emit('update:modelValue', $event.target.value)"
        />
    </div>
</template>
